<div class="login-main-container"
  style="height: 100vh; display: flex; justify-content: center; align-items: center; overflow: hidden;">

  <div fxLayout="column" fxLayoutAlign="space-evenly center" style="max-height: 100vh; overflow-y: auto; width: 100%;">
    <!-- Use different card classes based on active view -->
    <div [ngClass]="isQrLoginView ? 'qr-login-card' : 'common-card'">

      <div #login *ngIf="isLoginView">
        <form #loginUserForm="ngForm" autocomplete="off">
          <div class="form-group row" style="padding-top: 2%;">
            <div style="text-align: center;" oncontextmenu="return false;">
              <img width="250px" src="assets/images/logos/PrimeRx-P3-Logo.jpg">
            </div>
          </div>



          <div class="form-group row " style="padding: 20px 0 12px 0;">
            <!-- <div> -->
            <mat-form-field appearance="outline" class="login-field" hideRequiredMarker>
              <mat-label>Username</mat-label>
              <input matInput name="UserName" #UserName="ngModel" id="UserName" style="background-color: transparent;"
                [(ngModel)]="user.userName" autocomplete="off" required>
              <mat-error *ngIf="UserName.invalid && (UserName.dirty || UserName.touched)">
                Please enter user name
              </mat-error>
              <!-- <div *ngIf="UserName.invalid && (UserName.dirty || UserName.touched)"
                                                      id="UserNameError">
                                                      Please enter user name
                                                    </div> -->
            </mat-form-field>



          </div>



          <div class="form-group row" style="padding: 0px 0 12px 0;">
            <div>
              <mat-form-field appearance="outline" class="login-field" hideRequiredMarker>
                <mat-label>Password</mat-label>
                <input matInput name="password" #password="ngModel" id="password" [(ngModel)]="user.password"
                  [type]="hide ? 'password' : 'text'" autocomplete="new-password" required>

                <!-- Replace mat-icon with img tag -->
                <img class="pointer" *ngIf="!hide" width="30px"
                  style="text-align: right; padding-right: 10px; margin-bottom: -5px; " matSuffix class=""
                  src="assets/images/icons/icon-visibility-ON.png" alt="Toggle Password Visibility" (click)="hide = !hide">
                <img class="pointer" *ngIf="hide" width="30px"
                  style="text-align: right; padding-right: 10px; justify-content: center; margin-bottom: -5px; " matSuffix
                  src="assets/images/icons/icon-visibility-OFF.png" alt="Toggle Password Visibility" (click)="hide = !hide">


                <mat-error *ngIf="password.invalid && (password.dirty || password.touched)">
                  Please enter password
                </mat-error>

              </mat-form-field>
            </div>

          </div>



          <div class="form-group row">
            <!-- reCAPTCHA v2 checkbox -->
            <div id="recaptcha-wrapper">
              <div #recaptchaElement id="recaptcha-element"></div>
            </div>

            <div *ngIf="recaptchaInvalid" class="invalid-feedback">
              <mat-error>
                Please verify that you are not a robot
              </mat-error>
            </div>
          </div>



          <div style="padding-top: 10px;">
            <div style="padding-top: 6px; text-align: center;">
              <button id="loginBtn" mat-raised-button [disabled]="loginUserForm.invalid" style="display: flex; width: 100px; height: 50px; padding: 8px 16px;
                                                            justify-content: center; align-items: center; gap: 4px; font-size: 16px; font-weight: normal;
                                                            color: #FFFFFF; background: var(--Blue, #0C7BB8); opacity: 1; border-radius: 4px; margin: 0 auto;
                                                            box-shadow: 0 6px 10px 4px rgba(0, 0, 0, 0.15), 0 2px 3px 0 rgba(0, 0, 0, 0.30);
                                                            {{ loginUserForm.invalid ? 'background: #ADADAD;' : '' }}"
                (click)="loginUser();">Login</button>
            </div>
          </div>


          <div class="form-group row" style="padding-bottom: 5px;">

          </div>
        </form>
        <div style="padding-top: 10px; text-align: center; color: #0C7BB8;">
          <a (click)="forgotPassword()"
            style="cursor: pointer; color: #0C7BB8; text-decoration: underline; font-size: 14px; ">Forgot Password?</a>
        </div>
        <!-- <div style="padding-top: 40px; text-align: center;">
          <a (click)="showQrLogin()" class="qr-login-link">
            <img src="assets/images/icons/qr_code_scanner_24dp.svg" alt="QR Code Scanner">
            <span>Login using QR ></span>
          </a>
        </div> -->
        </div>

        <!-- QR Login View -->
        <!-- <div #qrLoginPage *ngIf="isQrLoginView" style="width: 100%;">
          <div style="text-align: center; padding: 20px;">
            Hidden input for QR scanner
            <input #qrInput type="text" (input)="onQrInputChange($event)" (blur)="onQrInputBlur()"
              style="position: absolute; left: -9999px; opacity: 0;" autocomplete="off" placeholder="Scan QR code here">

            <img src="assets/images/icons/QR_CodeAnim.gif" alt="QR Scanner"
              style="width: 125px; height: 125px; margin-bottom: 20px;">

            <h2 style="color: #0C7BB8; font-size: 22px; font-weight: 600; margin-bottom: 12px;">
              Scan your QR code
            </h2>

            <div style="display: flex; justify-content: center; margin-top: 44px;">
              <button type="button" mat-raised-button class="cancel-button" (click)="goToLoginPage()">
                Cancel
              </button>
            </div>
          </div>
        </div> -->

        <div #forgotPasswordPage *ngIf="isForgotPasswordView" style="width: 100%;">

        <p class="loginHeader">Forgot Password</p>
        <div style="padding-bottom: 16px;">
          <p class="loginFormText">Please confirm your registered</p>
          <p class="loginFormText">Email <span class="masked-value">{{ maskedEmail }}</span></p>
          <p class="loginFormText">Mobile No. <span class="masked-value">{{ maskedMobile }}</span></p>
        </div>

        <form action="">

          <div class="form-group row" style="padding: 20px 0 12px 0;">
            <mat-form-field appearance="outline" class="login-field" hideRequiredMarker>
              <mat-label>Email</mat-label>
              <input matInput name="Email" #EmailAddress="ngModel" id="Email" style="background-color: transparent;"
                [(ngModel)]="EnteredEmailForOTP" required email
                pattern="^[a-zA-Z0-9]+([._\-][a-zA-Z0-9]+)*@[a-zA-Z0-9\-]+(\.[a-zA-Z]{2,})+$">
              <mat-error *ngIf="EmailAddress.invalid && (EmailAddress.dirty || EmailAddress.touched)"
                class="invalid-feedback">
                <ng-container *ngIf="EmailAddress.errors?.['required']">Please enter email id</ng-container>
                <ng-container *ngIf="EmailAddress.errors?.['email'] || EmailAddress.errors?.['pattern']">Please enter
                  valid email</ng-container>
              </mat-error>
            </mat-form-field>
          </div>

          <div class="form-group row" style="padding: 0px 0 12px 0;">
            <mat-form-field appearance="outline" class="login-field" hideRequiredMarker>
              <mat-label>Mobile No</mat-label>
              <input matInput name="MobileNumber" #MobileNumber="ngModel" id="MobileNumber"
                style="background-color: transparent;" [(ngModel)]="EnteredMobileForOTP" [mask]="'(000)000-0000'"
                required>
              <mat-error *ngIf="MobileNumber.invalid && (MobileNumber.dirty || MobileNumber.touched)">
                Please enter your mobile number
              </mat-error>
            </mat-form-field>
          </div>

          <div class="button-container">
            <button type="button" mat-raised-button class="cancel-button" (click)="goToLoginPage()">Cancel</button>
            <button type="submit" mat-raised-button class="login-blue-button" [disabled]="false"
              (click)="sendOTPCode()">Send OTP</button>
          </div>
        </form>
      </div>


      <div #EnterOTPPage *ngIf="isEnterOTPView" style="justify-content: center; align-items: center;">
        <p class="loginHeader">Enter OTP</p>

        <div>
          <p class="loginFormText">Please enter the 6 digit OTP sent to your</p>
          <p class="loginFormText">registered email and mobile number.</p>
        </div>
        <form action="">
          <div style="display: flex; justify-content: center; align-items: center; gap: 10px; padding: 24px 0;">
            <input *ngFor="let _ of otpDigits; let i = index; trackBy: trackByIndex" id="otp-{{ i }}" type="text"
              class="otp-input" [(ngModel)]="otpDigits[i]" name="otp-{{ i }}" maxlength="1" autocomplete="off"
              draggable="false" (input)="onOtpInput($event, i)" (keydown)="onOtpKeydown($event, i)"
              (focus)="onOtpFocus($event, i)" (paste)="onOtpPaste($event)" (dragstart)="$event.preventDefault()"
              (drop)="$event.preventDefault()" />
          </div>

          <div class="button-container">
            <button type="button" mat-raised-button class="cancel-button" (click)="goToLoginPage()">Cancel</button>
            <button type="submit" mat-raised-button class="login-blue-button" (click)="verifyOTP()"
              [disabled]="false">Verify OTP</button>
          </div>
        </form>

        <div class="resend-otp-section">
          <p class="resend-otp-heading">Haven't got OTP yet?</p>
          <div *ngIf="isResendDisabled" class="countdown-container">
            <span class="countdown-text">Resend OTP in</span>
            <span class="countdown-timer">{{ otpCountdownDisplay }}</span>
          </div>
          <span *ngIf="!isResendDisabled" class="resend-link" (click)="resendOTP()">Resend OTP</span>
        </div>
      </div>


      <div #SetNewPasswordPage *ngIf="isSetNewPasswordView" style="width:100%">
        <p style="color: #0C7BB8; font-size: 30px; font-weight: 500; text-align: center; padding: 24px 0;">Set New
          Password</p>

        <form action="">
          <div class="form-group row">
            <div>
              <mat-form-field appearance="outline" class="login-field">
                <mat-label>Password</mat-label>
                <input matInput name="password" #newPassword="ngModel" id="newPassword" [(ngModel)]="user.newPassword"
                  [type]="hideNewPassword ? 'password' : 'text'" (ngModelChange)="checkPasswordStrength($event)"
                  (focus)="panelOpenState = true" (blur)="panelOpenState = false"
                  (keydown.space)="$event.preventDefault()">

                <!-- Replace mat-icon with img tag -->
                <img class="pointer" *ngIf="!hideNewPassword" width="30px"
                  style="text-align: right; padding-right: 10px; margin-bottom: -5px; " matSuffix class=""
                  src="assets/images/icons/icon-visibility-ON.png" alt="Toggle Password Visibility"
                  (mousedown)="$event.preventDefault()" (click)="hideNewPassword = !hideNewPassword">
                <img class="pointer" *ngIf="hideNewPassword" width="30px"
                  style="text-align: right; padding-right: 10px; justify-content: center; margin-bottom: -5px; "
                  matSuffix src="assets/images/icons/icon-visibility-OFF.png" alt="Toggle Password Visibility"
                  (mousedown)="$event.preventDefault()" (click)="hideNewPassword = !hideNewPassword">


                <mat-error *ngIf="newPassword.invalid && (newPassword.dirty || newPassword.touched)">
                  Please enter password
                </mat-error>

              </mat-form-field>
            </div>
          </div>

          <div>
            <div>
              <mat-form-field appearance="outline" class="login-field">
                <mat-label>Retype Password</mat-label>
                <input matInput name="retypePassword" #retypePassword="ngModel" id="retypePassword"
                  [(ngModel)]="user.retypePassword" [type]="hideRetypePassword ? 'password' : 'text'"
                  (keydown.space)="$event.preventDefault()">

                <!-- Replace mat-icon with img tag -->
                <img class="pointer" *ngIf="!hideRetypePassword" width="30px"
                  style="text-align: right; padding-right: 10px; margin-bottom: -5px; " matSuffix class=""
                  src="assets/images/icons/icon-visibility-ON.png" alt="Toggle Password Visibility"
                  (click)="hideRetypePassword = !hideRetypePassword">
                <img class="pointer" *ngIf="hideRetypePassword" width="30px"
                  style="text-align: right; padding-right: 10px; justify-content: center; margin-bottom: -5px; "
                  matSuffix src="assets/images/icons/icon-visibility-OFF.png" alt="Toggle Password Visibility"
                  (click)="hideRetypePassword = !hideRetypePassword">


                <mat-error *ngIf="retypePassword.invalid && (retypePassword.dirty || retypePassword.touched)">
                  Please re-enter password
                </mat-error>

              </mat-form-field>
            </div>
          </div>

          <!-- Password Complexity Panel -->
          <div style="margin-top: 16px; margin-bottom: 16px;">
            <mat-accordion>
              <mat-expansion-panel [expanded]="panelOpenState" (opened)="panelOpenState = true"
                (closed)="panelOpenState = false">
                <mat-expansion-panel-header>
                  <mat-panel-description style="display: flex; align-items: center; gap: 8px;">
                    <mat-icon *ngIf="!panelOpenState" style="color: #0C7BB8;">arrow_forward</mat-icon>
                    <mat-icon *ngIf="panelOpenState" style="color: #0C7BB8;">arrow_downward</mat-icon>
                    <span style="font-weight: 600;">
                      Check password strength
                    </span>
                  </mat-panel-description>
                </mat-expansion-panel-header>

                <div style="padding: 10px; padding-top: 2px;">

                  <div class="strength-feedback"
                    style="display: flex; align-items: center; gap: 6px; margin-bottom: 10px;">
                    <mat-icon style="font-size: 18px; width: 18px; height: 18px;"
                      [style.color]="strengthColor === 'warn' ? '#f44336' : strengthColor === 'accent' ? '#ff9800' : strengthColor === 'primary' ? '#4caf50' : '#9e9e9e'">
                      {{strengthIcon}}
                    </mat-icon>
                    <span style="font-weight: 600; font-size: 13px;"
                      [style.color]="strengthColor === 'warn' ? '#f44336' : strengthColor === 'accent' ? '#ff9800' : strengthColor === 'primary' ? '#4caf50' : '#9e9e9e'">
                      {{strengthMessage}}
                    </span>
                  </div>

                  <ul style="list-style: none; padding: 0; margin: 0;">
                    <li style="display: flex; align-items: center; gap: 6px; margin-bottom: 6px; font-size: 12px;"
                      [style.color]="hasMinLength ? '#4caf50' : '#757575'">
                      <mat-icon style="font-size: 16px; width: 16px; height: 16px;">{{ hasMinLength ? 'check_circle' :
                        'cancel' }}</mat-icon>
                      Contains at least 8 characters
                    </li>
                    <li style="display: flex; align-items: center; gap: 6px; margin-bottom: 6px; font-size: 12px;"
                      [style.color]="hasUpperCase ? '#4caf50' : '#757575'">
                      <mat-icon style="font-size: 16px; width: 16px; height: 16px;">{{ hasUpperCase ? 'check_circle' :
                        'cancel' }}</mat-icon>
                      Contains at least one uppercase letter
                    </li>
                    <li style="display: flex; align-items: center; gap: 6px; margin-bottom: 6px; font-size: 12px;"
                      [style.color]="hasLowerCase ? '#4caf50' : '#757575'">
                      <mat-icon style="font-size: 16px; width: 16px; height: 16px;">{{ hasLowerCase ? 'check_circle' :
                        'cancel' }}</mat-icon>
                      Contains at least one lowercase letter
                    </li>
                    <li style="display: flex; align-items: center; gap: 6px; margin-bottom: 6px; font-size: 12px;"
                      [style.color]="hasNumber ? '#4caf50' : '#757575'">
                      <mat-icon style="font-size: 16px; width: 16px; height: 16px;">{{ hasNumber ? 'check_circle' :
                        'cancel' }}</mat-icon>
                      Contains at least one number
                    </li>
                    <li style="display: flex; align-items: center; gap: 6px; font-size: 12px;"
                      [style.color]="hasSpecialChar ? '#4caf50' : '#757575'">
                      <mat-icon style="font-size: 16px; width: 16px; height: 16px;">{{ hasSpecialChar ? 'check_circle' :
                        'cancel' }}</mat-icon>
                      Contains at least one special character
                    </li>
                  </ul>
                </div>
              </mat-expansion-panel>
            </mat-accordion>
          </div>

          <div class="button-container">
            <button type="button" mat-raised-button class="cancel-button" (click)="goToLoginPage()">Cancel</button>
            <button type="submit" mat-raised-button class="login-blue-button" [disabled]="false"
              (click)="resetForgotPassword()">Update</button>
          </div>
        </form>

      </div>

    </div>

    <div style="padding-top: 26px;text-align: center;">
      <mat-label style=" float: center; cursor:auto;font-size: 13px;font-weight: normal;">
        © 2025 Micro Merchant Systems, Inc.
        <br>
        Version P3v18.1 All rights reserved.
      </mat-label>
    </div>
  </div>
</div>
